module.exports = __webpack_public_path__ + "img/defaultImg.84f74647.png";